<template>
	<div>
		<multiselect
			v-model="proxyValue"
			:options="fieldInfo.options"
			label="name"
			track-by="name"
			:multiple="true"
			:close-on-select="false"
			:clear-on-select="false"
			:preserve-search="true"
			:preselect-first="false"
			:placeholder="fieldInfo.placeholder"
			:disabled="!active"
		></multiselect>

		<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`">
			{{ errors[fieldInfo.name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
	components: { Multiselect },
	props: {
		fieldInfo: {
			type: Object
		},
		value: {
			type: Array
		},
		errors: {
			type: Object
		},
		state: {
			type: Boolean,
			default: null
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		}
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", this.fieldInfo.name);
			}
		}
	},
	data() {
		return {
			active: true,
			options: []
		};
	},
	beforeMount() {
		this.active = typeof this.isActive == "function" ? this.isActive(null) : this.isActive;
	}
};
</script>
